<template>
    <div class="stack mb-5">
        <div class="m-auto text-left control-width border shadow add-rounded p-4">
            <h3 class="mb-3 kova-text">Work with Africa's top talent on demand</h3>

            <h5 class="mb-3 font-weight-bold kova-text">How well do you communicate in English?</h5>          
                <!-- <input type="text" class="input m-auto" id="opt1" placeholder="Full name"/> -->
                    <a-slider id="test" :min="10" :max="100" :defaultValue="50"/>
            <div>
                <h5 class="mt-4 mb-3 font-weight-bold kova-text">Select your speciality</h5>          
                    <a-select class="w-100" size="large" placeholder="choose your area of speciality" style="width: 120px" v-model="speciality">
                        <a-select-option :key="stack" v-for="stack in stacks">
                            {{stack}}</a-select-option>
                    </a-select>
            </div>


            <div class="mt-4" v-if="showForFrontEnd">
                <!-- <p>Front-end</p> -->
                <h5 class="font-weight-bold kova-text">What is your top 1 tech stack expertise for front-end?</h5>
                <a-select class="w-100" size="large" placeholder="Select your front-end stack" style="width: 120px">
                        <a-select-option v-for="front in frontEndStacks" :key="front">
                            {{front}}</a-select-option>
                </a-select>
                
                <h5 class="mt-4 font-weight-bold kova-text">Projects you've built with your front-end stack?</h5>
                        <span class="font-weight-bold">How many?<a-input-number class="ml-2" size="large" :min="0" :max="10" placeholder="0" @change="displayLink"/></span><br />
                        <div :key="n" v-for="n in numLinkFrontEnd">
                            <a-input class="mt-3 w-75" addonBefore="https://" placeholder="add project link" /><br/>
                        </div>
            </div>



            <div class="mt-4" v-if="showForBackEnd">
                <!-- <p>Back-end</p> -->
                <h5 class="font-weight-bold kova-text">What is your top 1 tech stack expertise for Back-end?</h5>
                <a-select class="w-100" size="large" placeholder="Select your Back-end stack" style="width: 120px">
                        <a-select-option v-for="back in backEndStacks" :key="back">
                            {{back}}</a-select-option>
                </a-select>

                <h5 class="mt-4 font-weight-bold kova-text">Projects you've built with your back-end stack?</h5>
                        <span class="font-weight-bold">How many?<a-input-number class="ml-2" size="large" :min="0" :max="10" placeholder="0" @change="displayLinkBack"/></span><br />
                        <div :key="n" v-for="n in numLinkBackEnd">
                            <a-input class="mt-3 w-75" addonBefore="https://" placeholder="add project link" /><br/>
                        </div>
            </div>



            <div class="mt-4" v-if="showForOther">
                <h5 class="font-weight-bold kova-text">What's your core tech stack?</h5>
                <a-input class="w-100 mb-3" size="large" placeholder="Your core tech stack here" />
                <span class="font-weight-bold">How many?<a-input-number class="ml-2" size="large" :min="0" :max="10" placeholder="0" @change="displayLinkOthers" /></span><br />
                <div :key="n" v-for="n in numLinkOthers">
                            <a-input class="mt-3 w-75" addonBefore="https://" placeholder="add project link" /><br/>
                        </div>
            </div>
            <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                    </div>
                    <div class="col text-right">
                         <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                    </div>
                </div>
            </div>
            
        </div>
        
 </div>
</template>
<script>

export default {
    name: 'stack',
    data(){
        return {
            stacks: [
                'Front-end', 'Back-end', 'Full Stack', 'Android', 'IOS', 'CyberSecurity',
                'A.I', 'Blockchain', 'Integration', 'DApp', 'DevOps', 'Others'],
            frontEndStacks: ['HTML, CSS, JavaScript', 'Vue', 'React', 'Angular', 'jQuery', 'Others'],
            backEndStacks: ['PHP', 'Nodejs', 'Django', 'Flask', 'Laravel', 'Java', 'C#', 'C++', '.NET', 
                            'Ruby', 'Scala', 'Perl', 'Symfony', 'Spring', 'JSF', 'Others' ],
            speciality:'',
            showForFrontEnd: false,
            showForBackEnd: false,
            showForOther: false,
            numLinkFrontEnd: 0,
            numLinkBackEnd: 0,
            numLinkOthers: 0,
        }
    },
    watch: {
        speciality: function(){
            if(this.speciality == 'Front-end'){
                this.showForOther = false;
                this.showForBackEnd = false;
                return this.showForFrontEnd = true;
            }
            else if(this.speciality == 'Back-end'){
                this.showForOther = false;
                this.showForFrontEnd = false;
                return this.showForBackEnd = true;
            }
            else if (this.speciality == 'Full Stack'){
                this.showForOther = false;
                return this.showForFrontEnd = true, this.showForBackEnd = true;
            }else{
                this.showForOther = true;
                return this.showForFrontEnd = false, this.showForBackEnd = false
            }
        },
    },
    methods: {
        goBack(){
            this.$router.go(-1);
        },
        next(){
            this.$router.push('devsignup/speciality');
        },
        displayLink(value){
            this.numLinkFrontEnd = value;
        },
        displayLinkBack(value){
            this.numLinkBackEnd = value;
        },
        displayLinkOthers(value){
            this.numLinkOthers = value;
        }
    }
}
</script>
<style scoped>

.input{
    width: 90%;
    height: 50px;
    outline: 0;
    border: solid 1px #20409a;
    border-radius: 5px;
}
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>